import { SwiperOptions } from 'swiper/types';
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules'


const there_is_sidebar = document.querySelector('.sidebar');
const is_subservice = document.querySelector('.subservice');

const swiperServicesParams: SwiperOptions = {
    modules: [Navigation],
    slidesPerView: 1,
    loop: true,
    navigation: {
        nextEl: ".slider_services>.swiper-button-next",
        prevEl: ".slider_services>.swiper-button-prev",
    },
    breakpoints: {
        577: {
            slidesPerView: 2,
            spaceBetween: 30,
        },
        993: {
            slidesPerView: !there_is_sidebar ? 3 : 2,
            spaceBetween: !there_is_sidebar ? 30 : 20,
        },
        1201: {
            slidesPerView: !there_is_sidebar ? 4 : 3,
            spaceBetween: !there_is_sidebar ? 30 : 20,
        }
    }
};
const swiperDocumentsParams: SwiperOptions = {
    modules: [Navigation],
    slidesPerView: 1,
    loop: true,
    navigation: {
        nextEl: ".slider_documents>.swiper-button-next",
        prevEl: ".slider_documents>.swiper-button-prev",
    },
    breakpoints: {
        577: {
            slidesPerView: 2,
            spaceBetween: 30,
        },
        993: {
            slidesPerView: 3,
            spaceBetween: !there_is_sidebar ? 30 : 20,
        },
        1200: {
            slidesPerView: !there_is_sidebar ? 4 : 3,
            spaceBetween: !there_is_sidebar ? 30 : 20,
        }
    }
};
const swiperLicensesParams: SwiperOptions = {
    modules: [Navigation],
    slidesPerView: 1,
    loop: true,
    navigation: {
        nextEl: ".slider_licenses>.swiper-button-next",
        prevEl: ".slider_licenses>.swiper-button-prev",
    },
    breakpoints: {
        577: {
            slidesPerView: 2,
            spaceBetween: 30,
        },
        993: {
            slidesPerView: 3,
            spaceBetween: !there_is_sidebar ? 30 : 20,
        },
        1200: {
            slidesPerView: !there_is_sidebar ? 4 : 3,
            spaceBetween: !there_is_sidebar ? 30 : 20,
        }
    }
};
const swiperReviewsParams: SwiperOptions = {
    modules: [Navigation],
    slidesPerView: 1,
    loop: true,
    navigation: {
        nextEl: ".slider_reviews>.swiper-button-next",
        prevEl: ".slider_reviews>.swiper-button-prev",
    },
    breakpoints: {
        577: {
            slidesPerView: 2,
            spaceBetween: 30,
        },
        993: {
            slidesPerView: 3,
            spaceBetween: !there_is_sidebar ? 30 : 20,
        },
        1200: {
            slidesPerView: !there_is_sidebar ? 4 : 3,
            spaceBetween: !there_is_sidebar ? 30 : 20,
        }
    }
};
const swiperProjectsParams: SwiperOptions = {
    modules: [Navigation],
    slidesPerView: 1,
    loop: true,
    navigation: {
        nextEl: ".slider_projects>.swiper-button-next",
        prevEl: ".slider_projects>.swiper-button-prev",
    },
    breakpoints: {
        577: {
            slidesPerView: 2,
            spaceBetween: is_subservice ? 30 : 10,
        },
        993: {
            slidesPerView: 2,
            spaceBetween: is_subservice ? 20 : 10,
        }
    }
};
const swiperClientsParams: SwiperOptions = {
    modules: [Navigation, Pagination],
    slidesPerView: 2,
    spaceBetween: 10,
    loop: true,
    navigation: {
        nextEl: ".slider_clients>.swiper-button-next",
        prevEl: ".slider_clients>.swiper-button-prev",
    },
    pagination: {
        el: '.slider_clients>.swiper-pagination',
        clickable: true,
    },
    breakpoints: {
        577: {
            slidesPerView: 3,
            spaceBetween: 30,
        },
        993: {
            slidesPerView: 4,
            slidesPerGroup: 4,
            spaceBetween: !there_is_sidebar ? 30 : 20,
        },
        1200: {
            slidesPerView: !there_is_sidebar ? 5 : 4,
            slidesPerGroup: !there_is_sidebar ? 5 : 4,
            spaceBetween: !there_is_sidebar ? 30 : 20,
        }
    }
};
const swiperEmployeesParams: SwiperOptions = {
    modules: [Navigation],
    slidesPerView: 1,
    loop: true,
    navigation: {
        nextEl: ".slider_employees>.swiper-button-next",
        prevEl: ".slider_employees>.swiper-button-prev",
    },
    breakpoints: {
        577: {
            slidesPerView: 2,
        },
        993: {
            slidesPerView: !there_is_sidebar ? 3 : 2,
        },
        1200: {
            slidesPerView: 3,
        }
    }
}
const swiperArticlesParams: SwiperOptions = {
    modules: [Navigation],
    slidesPerView: 1,
    spaceBetween: 30,
    loop: true,
    navigation: {
        nextEl: ".slider_articles>.swiper-button-next",
        prevEl: ".slider_articles>.swiper-button-prev",
    },
    breakpoints: {
        577: {
            slidesPerView: 2,
            spaceBetween: 30,
        },
        993: {
            slidesPerView: !there_is_sidebar ? 3 : 2,
            spaceBetween: !there_is_sidebar ? 30 : 20,
        },
        1201: {
            slidesPerView: !there_is_sidebar ? 4 : 3,
            spaceBetween: !there_is_sidebar ? 30 : 20,
        }
    }
};

const swiperServices = new Swiper('.slider_services>.slider__swiper', swiperServicesParams);
const swiperDocuments = new Swiper('.slider_documents>.slider__swiper', swiperDocumentsParams);
const swiperLicenses = new Swiper('.slider_licenses>.slider__swiper', swiperLicensesParams);
const swiperReviews = new Swiper('.slider_reviews>.slider__swiper', swiperReviewsParams);
const swiperProjects = new Swiper('.slider_projects>.slider__swiper', swiperProjectsParams);
const swiperClients = new Swiper('.slider_clients>.slider__swiper', swiperClientsParams);
const swiperEmployees = new Swiper('.slider_employees>.slider__swiper', swiperEmployeesParams);
const swiperArticles = new Swiper('.slider_articles>.slider__swiper', swiperArticlesParams);
